"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserFormQuestionType = void 0;
var UserFormQuestionType;
(function (UserFormQuestionType) {
    UserFormQuestionType["TRUE_OR_FALSE"] = "TRUE_OR_FALSE";
    UserFormQuestionType["MULTIPLE_CHOICE"] = "MULTIPLE_CHOICE";
    UserFormQuestionType["DATE_INPUT"] = "DATE_INPUT";
    UserFormQuestionType["SINGLE_OPTION"] = "SINGLE_OPTION";
    UserFormQuestionType["TEXT_INFO"] = "TEXT_INFO";
})(UserFormQuestionType = exports.UserFormQuestionType || (exports.UserFormQuestionType = {}));
